import * as React from 'react';
import { styled } from '@glitz/react';
import { IconLink } from 'webapp/shell/main-menu/IconLink';
import Item from 'webapp/shell/main-menu/Item';
import { Promo } from 'webapp/shell/main-menu/Promo';
import { bareListDecorator } from 'webapp/decorators/list';
import { translate } from '@avensia/excite';
import { addNavigationEventToDataLayer } from 'webapp/tracking/events/main-navigation';
import { isNordicNest } from 'webapp/theme';

type PropType = {
  menu: NordicNest.Api.CfMenuApiModel;
  close: () => void;
};

export function MenuHighlights({ menu, close }: PropType): React.JSX.Element {
  return (
    <Container>
      <Heading>{translate(t => t.mobileMenu.rootLevelHeading)}</Heading>
      <SecondaryMenuItems>
        {menu?.secondaryLinks.map((menuItem, i) => (
          <LinkItem
            key={menuItem.link.to + i}
            onClick={() => addNavigationEventToDataLayer({ ...menuItem, menu_type: 'side', menu_category: 'level_0' })}
          >
            <Item item={menuItem} />
          </LinkItem>
        ))}
        {menu?.promo && (
          <Promo
            promo={menu?.promo}
            onClick={() => {
              close();
              addNavigationEventToDataLayer({ to: menu?.promo?.path, menu_type: 'side', menu_category: 'promo' });
            }}
          />
        )}
        {menu?.secondaryTopLinks && (
          <SecondaryLinks>
            {menu.secondaryTopLinks.map((link, i) => (
              <li key={link.link.to + i}>
                <IconLink menuItem={link} compact navigationData={{ menu_type: 'side', menu_category: 'level_0' }} />
              </li>
            ))}
          </SecondaryLinks>
        )}
      </SecondaryMenuItems>
    </Container>
  );
}

const SecondaryLinks = styled.ul(bareListDecorator, {
  fontSize: t => t.fontSize.xxs,
  padding: { top: t => t.spacing.m, bottom: t => t.spacing.xl },
});

const Heading = styled.h1(
  {
    fontSize: t => t.header?.menuHeadingFontSize,
    textTransform: t => t.header?.menuTextTransform,
    padding: { x: t => t.spacing.l },
  },
  isNordicNest && {
    marginLeft: -3, //To make up for font not filling out the container
  },
);

const Container = styled.div({
  padding: { y: t => t.sharedSpacing.xxl },
});

const SecondaryMenuItems = styled.ul(bareListDecorator);

const LinkItem = styled.li({
  textTransform: t => t.header?.menuTextTransform,
  fontSize: t => t.header?.subCategoryFontSize,
  [':hover:not(:has(> button))' as any]: {
    textDecoration: 'underline',
  },
});
